import { PAGES } from './analytics';
import { GENERIC_ANALYTICS_EVENTS } from './analyticsGenericEvents';

type CtaClickedTrackingPayload = {
  buttonLabel: string;
  url?: string;
  vrm?: string | boolean;
};

const DEFAULT_PAYMENT_TRACKING_PAYLOAD = {
  category: PAGES.VEHICLE_PAYMENT,
} as const;

export const PAYMENT_PAGE_EVENTS = {
  VEHICLE_PAYMENT_ACCEPT_NEW_OFFER_BUTTON_CLICKED: (
    { buttonLabel, vrm }: CtaClickedTrackingPayload,
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    button_label: buttonLabel,
    label: 'Accept_new_offer_button_clicked',
    name: 'Accept new offer button clicked',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_ACCOUNT_BUTTON_CLICKED: (
    { buttonLabel, url = '/account' }: CtaClickedTrackingPayload,
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    button_label: buttonLabel,
    label: 'Account_button_clicked',
    name: 'Account button clicked',
    url,
  }),
  VEHICLE_PAYMENT_BACK_BUTTON_CLICKED: (
    { buttonLabel, vrm }: CtaClickedTrackingPayload,
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    button_label: buttonLabel,
    label: 'Back_button_clicked',
    name: 'Back button clicked',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_CONFIRM_NEW_OFFER_MODAL_CLOSED: (vrm: string | undefined) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    name: 'Confirm new offer modal closed',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_CONTACT_BUTTON_CLICKED: (
    { buttonLabel, vrm }: CtaClickedTrackingPayload,
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    button_label: buttonLabel,
    label: 'Contact_button_clicked',
    name: 'Contact button clicked',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_CONTINUE_BUTTON_CLICKED: (
    { buttonLabel, vrm }: CtaClickedTrackingPayload,
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    button_label: buttonLabel,
    label: 'Continue_to_payment_button_clicked',
    name: 'Continue to payment button clicked',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_CONTINUE_WITH_OFFER_MODAL_OPENED: (
    { buttonLabel, vrm }: CtaClickedTrackingPayload,
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    button_label: buttonLabel,
    name: 'Continue with offer modal opened',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_PROCESSING_MODAL_CLOSED: (vrm: string | undefined) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    name: 'Processing payment modal closed',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_RECEIVE_PAYMENT_BUTTON_CLICKED: (
    { buttonLabel, vrm }: CtaClickedTrackingPayload,
  ) => GENERIC_ANALYTICS_EVENTS.CTA_CLICK({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    button_label: buttonLabel,
    label: 'Receive_payment_button_clicked',
    name: 'Receive payment button clicked',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
  VEHICLE_PAYMENT_SUCCESS_MODAL_CLOSED: (vrm: string | undefined) => GENERIC_ANALYTICS_EVENTS.CLICK_EVENT({
    ...DEFAULT_PAYMENT_TRACKING_PAYLOAD,
    name: 'Success payment modal closed',
    url: `/${vrm ?? 'vrm'}/vehicle-payment`,
  }),
} as const;
